module.exports = __webpack_public_path__ + "assets/media/email_sent.3ef76fdc.svg";